// Reglas de acceso a rutas del dashboard (App.js, Sidenav y login).
//
// Regla del POS de eventos (permiso 71, pantalla "VentaEvento"):
// - Administrador: ve y opera el POS sin el permiso 71 (conserva su bypass).
// - Resto de usuarios: no importa el tipo de usuario; solo el permiso 71 habilita
//   el POS. Con SOLO el 71 (ninguna otra pantalla), el usuario ve únicamente el
//   POS: cualquier otra ruta, incluidas las públicas (/cocina, /carta,
//   /recepcion, /sistema-comedor...), lo devuelve a /venta-evento (QA2-12).
// El backend aplica la misma regla (API/src/config/graphqlAccessPolicy.js).

export const PANTALLA_VENTA_EVENTO = "VentaEvento";
export const RUTA_VENTA_EVENTO = "/venta-evento";

export const esAdministrador = (user) => user?.tipoUser === "Administrador";

const pantallasDe = (user) =>
  (Array.isArray(user?.permisos) ? user.permisos : [])
    .map((permiso) => permiso?.pantalla)
    .filter(Boolean);

export const tienePantalla = (user, pantallas = []) => {
  const requeridas = [].concat(pantallas);
  return pantallasDe(user).some((pantalla) => requeridas.includes(pantalla));
};

/** Vendedor dedicado: no es Administrador y su única pantalla es VentaEvento. */
export const esVendedorSoloVentaEvento = (user) => {
  if (!user || esAdministrador(user)) return false;
  const pantallas = pantallasDe(user);
  return pantallas.length > 0 && pantallas.every((pantalla) => pantalla === PANTALLA_VENTA_EVENTO);
};

export const esRutaVentaEvento = (pathname = "") =>
  pathname === RUTA_VENTA_EVENTO || String(pathname).startsWith(`${RUTA_VENTA_EVENTO}/`);

/**
 * ¿Puede `user` abrir `route`? Sin usuario (sin sesión o cargando) se evalúan
 * solo las rutas públicas, como antes.
 */
export const puedeAccederRuta = (route, user) => {
  if (route?.soloAdministrador) return esAdministrador(user);
  if (esVendedorSoloVentaEvento(user)) return route?.permiso === PANTALLA_VENTA_EVENTO;
  const pantallasRequeridas =
    route?.permisosDocumento ?? (route?.permiso ? [route.permiso] : []);
  return (
    pantallasRequeridas.length === 0 ||
    esAdministrador(user) ||
    tienePantalla(user, pantallasRequeridas)
  );
};

/** ¿Se muestra la entrada del menú lateral con este `permiso`? */
export const puedeVerEnMenu = (permiso, user) => {
  if (!user) return false;
  if (esVendedorSoloVentaEvento(user)) return permiso === PANTALLA_VENTA_EVENTO;
  return esAdministrador(user) || !permiso || tienePantalla(user, permiso);
};
